<template lang="pug">
  div
    Action(
      v-if="stage === 'action'"
      :inputReadOnly="true"
      :defaultNum="amountPayload.emptyCount"
      :deviceId="currentEvent.device.id"
      v-on:setActionData="getThisAmount"
      :onlyPc="true"
    )  
      h5 此藥盒取出空瓶數量
    Loader(v-if="stage === 'finish'")
</template>

<script>
import axios from 'axios';
import Action from '../flowComp/Action';
import Loader from '../common/Loader';

export default {
  name: 'ActionWrap',
  props: ['amountPayload'],
  data() {
    return {
      stage: '',
    };
  },
  components: {
    Action,
    Loader,
  },
  computed: {
    currentEvent() {
      return this.$store.state.event.currentEvent;
    },
    currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
  mounted() {
    this.stage = 'action';
    this.$store.commit('SET_CURRENT_STEP', 'action');
  },
  methods: {
    async asyncForEach(promises) {
      console.log('start');
      // promises.forEach(async (p) => {
      //   console.log(p);
      //   await p;
      // });
      console.log('done');
    },
    async getThisAmount(data) {
      // 注意：回收空瓶數量是不能讓user調整的
      this.stage = 'finish';

      // 如果有先執行 refineSelectedEvents 的話
      if (this.currentEvent.sameDeviceEvent) {
        const promises = [];

        for (let i = 0; i < this.currentEvent.sameDeviceEvent.length; i += 1) {
          const currentEvent = this.currentEvent.sameDeviceEvent[i];
          const drugStorage = this.$store.state.drugInDevice.allDrugInDevice[currentEvent.drug_storage];

          // the "num" attribute is the amount of empty amount for returning.
          const sentData = {
            id: drugStorage.id,
            device: drugStorage.device.id,
            stock: drugStorage.stock,
            max_stock: drugStorage.max_stock,
            expired_date: drugStorage.expired_date,
            patch_number: drugStorage.patch_number,
            medication: drugStorage.medication.id,
            number1: currentEvent.number1,
            pack_count: drugStorage.pack_count,
            empty_count: drugStorage.empty_count - currentEvent.number1,
            type: 'RECYCLE_EMPTY',
          };
          // after saving the empty count to drugStorage, we need to update the event as returned.
          /* eslint-disable no-await-in-loop */
          await this.instance.put(`/api/drug-storage/${sentData.id}/`, sentData)
          .then(async (res) => {
            const recoredEventIDs = [];
            // keep the old relative event.
            currentEvent.related_events.forEach((item) => {
              if (item.id !== null) {
                recoredEventIDs.push(item.id);
              }
            });
            // add new.
            recoredEventIDs.push(res.data);
            const event = {
              id: currentEvent.id,
              checked: true,
              related_events: recoredEventIDs,
            };
            /* eslint-disable no-await-in-loop */
            await this.instance.patch(`/api/event/${event.id}/`, event);
          });
        }
        // await this.asyncForEach(promises);
        this.$emit('setActionData');
      } else {
        // the "num" attribute is the amount of empty amount for returning.
        const sentData = {
          id: this.currentDrugInDevice.id,
          device: this.currentDrugInDevice.device.id,
          stock: this.currentDrugInDevice.stock,
          max_stock: this.currentDrugInDevice.max_stock,
          expired_date: this.currentDrugInDevice.expired_date,
          patch_number: this.currentDrugInDevice.patch_number,
          medication: this.currentDrugInDevice.medication.id,
          number1: data.num,
          pack_count: this.currentDrugInDevice.pack_count,
          empty_count: this.currentDrugInDevice.empty_count - data.num,
          type: 'RECYCLE_EMPTY',
        };
        // after saving the empty count to drugStorage, we need to update the event as returned.
        this.instance.put(`/api/drug-storage/${sentData.id}/`, sentData)
        .then(async (res) => {
          const recoredEventIDs = [];
          this.currentEvent.related_events.forEach((item) => {
            if (item.id !== null) {
              recoredEventIDs.push(item.id);
            }
          });
          recoredEventIDs.push(res.data);
          const event = {
            id: this.currentEvent.id,
            checked: true,
            related_events: recoredEventIDs,
          };
          await this.instance.patch(`/api/event/${event.id}/`, event);
          this.$emit('setActionData');
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ActionWrap.vue?b40e74aa